import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../lib';
import { isPreviewPage } from '../../routes';
import { configSelectors } from '../../store';

const features = [
  '✔ Нет ограничений на количество сайтов',
  '✔ Возможность добавлять несколько виджетов одновременно на сайт',
  '✔ Конструктор форм: можно добавить любые поля: имя, город и т.п',
  '✔ Удобная работа с купонами',
  '✔ Больше возможностей для кастомизации виджетов',
];

export const SwitchVersion = () => {
  const isWix = useAppSelector(configSelectors.isWix);
  const [open, setOpen] = useState(false);

  if (isPreviewPage(window.location.pathname) || isWix) {
    return null;
  }

  return (
    <SwitchVersionWrapper>
      <Content>
        <TextDescription>Это новая версия сервиса, улучшенная и переработанная</TextDescription>

        <Button
          onClick={() => {
            setOpen(true);
          }}
          size="small"
          color="inherit"
        >
          Переключиться на старую версию
        </Button>
      </Content>

      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>Новая версия сервиса, улучшенная и переработанная</DialogTitle>

        <DialogContent>
          <Features>
            {features.map((feature) => (
              <li>{feature}</li>
            ))}
          </Features>

          <Alert severity="warning" sx={{ marginTop: '24px' }}>
            Старая версия развиваться не будет. Все обновления будут выходить только для новой версии
          </Alert>

          <Alert severity="warning" sx={{ marginTop: '12px' }}>
            Старая версия будет отключена в январе 2025 года
          </Alert>
        </DialogContent>

        <DialogActions>
          <Button href="https://embedgames.app/account" sx={{ marginRight: '24px' }}>
            Перейти на старую версию
          </Button>

          <Button
            variant="contained"
            onClick={() => {
              setOpen(false);
            }}
          >
            Остаться
          </Button>
        </DialogActions>
      </Dialog>
    </SwitchVersionWrapper>
  );
};

const SwitchVersionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  width: 100%;
  background-color: #1565c0;
  color: #fff;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1254px;
  margin: 0 auto;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const TextDescription = styled.span`
  margin-right: 24px;
`;

const Features = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  padding-left: 0;

  li:first-letter {
    color: #2bae66;
  }
`;
